import { Injectable } from '@angular/core';
import { Search } from '@df/search/search.interfaces';
import { SearchService } from '@df/search/search.service';

@Injectable()
export class ElasticsearchService extends SearchService {
    /**
     * Sends search request
     */
    protected doSearch(request: Search.IRequest): Promise<Search.IResult> {
        return this.requestService.send<Search.IResult>(undefined, { data: request, path: 'search/find?ver=2' });
    }
}
